import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationRU from "./locales/ru/translation.json";
import translationUZ from "./locales/uz/translation.json";

import uzFlag from "../layout/header/assets/icons/uzFlag.svg";
import ruFlag from "../layout/header/assets/icons/ruFlag.svg";
import enFlag from "../layout/header/assets/icons/enFlag.svg";

const resources = {
  en: {
    translation: translationEN,
  },
  ru: {
    translation: translationRU,
  },
  uz: {
    translation: translationUZ,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    keySeparator: "^",
    nsSeparator: "~",
    interpolation: {
      escapeValue: false,
    },
    resources,
  });

export const languageMenu = [
  {
    id: "2987bf89-0a39-4005-b75d-b612526bbd79",
    title: "ENG",
    code: "en",
    flag: enFlag,
  },
  {
    id: "8acc7d82-d909-4232-b40e-400e8875c271",
    title: "RUS",
    code: "ru",
    flag: ruFlag,
  },
  {
    id: "8acc7d82-d909-4232-b40e-400e8875c222",
    title: "UZB",
    code: "uz",
    flag: uzFlag,
  },
];

export default i18n;
